import { useEffect, useState } from "react";
import api from "../../utils/api";

export default function Monetization() {
  const [impressions, setImpressions] = useState(0);
  const [earning, setEarning] = useState(0);
  const [eligibility, setEligibility] = useState(null);
  const [loading, setLoading] = useState(true);
  const [requestLoading, setRequestLoading] = useState(false);

  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;

  const userId = user?._id;
  const channelId = user?.channelId;

  useEffect(() => {
    if (!channelId || !userId) {
      setLoading(false);
      return;
    }

    const loadMonetization = async () => {
      try {
        // ==========================
        // 1?? Earnings API
        // ==========================
        const earningsRes = await api.get("/client/channel-earnings", {
          params: { channelId, userId },
        });

        if (earningsRes?.data?.success) {
          const data = earningsRes.data.data || {};
          setImpressions(data.totalImpressions || 0);
          setEarning(Number(data.totalEarning || 0));
        }

        // ==========================
        // 2?? Eligibility API
        // ==========================
        const eligibilityRes = await api.get("/client/monetizationRequest/getMonetization", {
          params: { userId },
        });

        console.log("Eligibility Response:", eligibilityRes.data);

        if (eligibilityRes?.data?.status === true) {
          setEligibility(eligibilityRes.data.dataOfMonetization);
        } else {
          setEligibility(null);
        }

      } catch (error) {
        console.error("Monetization Load Error:", error);
        setEligibility(null);
      } finally {
        setLoading(false);
      }
    };

    loadMonetization();
  }, [channelId, userId]);

  // ==========================
  // Apply Request
  // ==========================
  const handleApply = async () => {
    try {
      setRequestLoading(true);

      const res = await api.post(
        "/client/monetizationRequest/createMonetizationRequest",
        null,
        { params: { userId } }
      );

      alert(res?.data?.message || "Request processed.");
    } catch (error) {
      console.error("Apply Error:", error);
      alert("Failed to submit request.");
    } finally {
      setRequestLoading(false);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 2,
    }).format(amount);
  };

  if (loading)
    return <p className="panel-loading">Loading monetization...</p>;

  return (
    <div className="panel-container">
      <h2>Monetization</h2>

      {/* ================= Earnings Section ================= */}
      <div className="stats-grid">
        <div className="stat-card">
          <h3>Total Impressions</h3>
          <p>
            {impressions >= 1000
              ? (impressions / 1000).toFixed(1) + "K"
              : impressions}
          </p>
        </div>

        <div className="stat-card">
          <h3>Total Earnings</h3>
          <p>{formatCurrency(earning)}</p>
        </div>
      </div>

      {/* ================= Eligibility Section ================= */}
      {eligibility && (
        <div className="eligibility-box">
          <h3>Monetization Eligibility</h3>

          <p>
            Minimum Subscribers Required:{" "}
            <strong>{eligibility.minSubScriber}</strong>
          </p>

          <p>
            Your Subscribers:{" "}
            <strong>{eligibility.totalSubscribers}</strong>
          </p>

          <p>
            Minimum Watch Time Required (Hours):{" "}
            <strong>{eligibility.minWatchTime}</strong>
          </p>

          <p>
            Your Watch Time (Hours):{" "}
            <strong>
              {Number(eligibility.totalWatchTime || 0).toFixed(2)}
            </strong>
          </p>

          {eligibility.totalSubscribers >= eligibility.minSubScriber &&
          eligibility.totalWatchTime >= eligibility.minWatchTime ? (
            <button
              className="apply-btn"
              onClick={handleApply}
              disabled={requestLoading}
            >
              {requestLoading ? "Submitting..." : "Apply for Monetization"}
            </button>
          ) : (
            <p className="not-eligible">
              You are not eligible yet for monetization.
            </p>
          )}
        </div>
      )}

      <div className="note">
        <p>
          Earnings calculated based on actual ad impressions and CPM rate.
        </p>
      </div>
    </div>
  );
}
